import { getLocalStorageItem } from '../utils/localStorageUtils';
/**
 * Centralized Muhurta Chakra default settings
 * Single source of truth for muhurta visibility defaults
 */

/**
 * Get default muhurta chakra visibility setting
 * @returns boolean - true by default (visible on page load)
 */
export const getDefaultMuhurtaChakraVisibility = (): boolean => {
    return false; // Changed back to true to test
};

/**
 * Get muhurta chakra setting from localStorage with fallback
 * @param chartId - chart identifier
 * @returns boolean - saved setting or default
 */
export const getMuhurtaChakraSettingForChart = (chartId: string): boolean => {
    const settings = getLocalStorageItem<Record<string, any> | null>(`chart-settings-${chartId}`, null);
    return settings?.showMuhurtaChakra ?? getDefaultMuhurtaChakraVisibility();
};